import { render } from "./NameCardList.vue?vue&type=template&id=d0a1ccce&scoped=true"
import script from "./NameCardList.vue?vue&type=script&lang=js"
export * from "./NameCardList.vue?vue&type=script&lang=js"

import "./NameCardList.vue?vue&type=style&index=0&id=d0a1ccce&scoped=true&lang=css"
import "./NameCardList.vue?vue&type=style&index=1&id=d0a1ccce&lang=css"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0a1ccce"]])

export default __exports__